// ** React Imports
import { useEffect } from 'react'
import { NavLink, useLocation, matchPath } from 'react-router-dom'
import { Badge } from 'reactstrap'
import { search, getAllParents } from '@layouts/utils'
import classnames from 'classnames'
import navigation from '@src/navigation/vertical'

const VerticalNavMenuLink = ({
  item,
  setGroupActive,
  activeItem,
  setActiveItem,
  setGroupOpen,
  toggleActiveGroup,
  parentItem,
  routerProps,
  currentActiveItem
}) => {
  const location = useLocation()
  const currentURL = location.pathname
  const match = matchPath({ path: `${item.navLink}/:param`, caseSensitive: false, end: true }, currentURL)

  const searchParents = (navigation, currentURL) => {
    const parents = search(navigation, currentURL, routerProps) // Search for parent object
    const allParents = getAllParents(parents, 'id') // Parents Object to Parents Array
    return allParents
  }

  const resetActiveGroup = navLink => {
    const parents = search(navigation, navLink, match)
    toggleActiveGroup(item.id, parents)
  }

  const resetActiveAndOpenGroups = () => {
    setGroupActive([])
    setGroupOpen([])
  }

  useEffect(() => {
    if (currentActiveItem !== null) {
      setActiveItem(currentActiveItem)
      const arr = searchParents(navigation, currentURL)
      setGroupActive([...arr])
    }
  }, [location])

  return (
    <li className={classnames({ 'nav-item': !item.children, disabled: item.disabled, active: item.navLink === activeItem })}>
      <NavLink
        to={item.navLink || '/'}
        className={({ isActive }) => classnames('d-flex align-items-center', { active: isActive })}
        onClick={e => {
          if (!item.navLink.length) e.preventDefault()
          parentItem ? resetActiveGroup(item.navLink) : resetActiveAndOpenGroups()
        }}>
        {item.icon}
        <span className='menu-item text-truncate'>{item.title}</span>
        {item.badge && item.badgeText ? (
          <Badge className='ml-auto mr-1' color={item.badge} pill>
            {item.badgeText}
          </Badge>
        ) : null}
      </NavLink>
    </li>
  )
}

export default VerticalNavMenuLink
